import { makeStyles } from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  tabsContainer: {
    borderBottom: '1px solid #103A99',
    borderTopRightRadius: '10px',
    borderTopLeftRadius: '10px',
    padding: '10px 0 5px 20px',
    '& .MuiTab-root': {
      fontSize: '11px',
    },
    '& .MuiTabs-root': {
      borderBottom: '1px solid #103A99',
      padding: '0 4%',
      '& .MuiTab-root': {
        width: 'calc(100%/7 - 2px)',
      }
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .tab': {
      padding: '20px 9%'
    },
    '& .MuiTab-textColorPrimary': {
      color: '#434343',
      backgroundColor: '#f0f8ff',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      margin: '5px 1px -1px',
      border: '1px solid #D0E9FF'
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      background: '#103A99',
      color: '#fff'
    },
    '& .MuiTableCell-body.MuiTableCell-root': {
      color: '#434343'
    }
  }
}));
